/**
 * V2PartnersPage — the "Development Partner" pitch for restoration orgs that
 * want a custom build. No checkout here: the conversion is a contact email.
 */
import { Card } from '../components/ui/card';
import { Button } from '../components/ui/button';

const CONTACT_EMAIL = 'info@anterotrail.com';

/** Org/partnership page (accessible to any logged-in user). */
export default function V2PartnersPage() {
  const mailto = `mailto:${CONTACT_EMAIL}?subject=${encodeURIComponent(
    'Development Partner inquiry',
  )}`;

  return (
    <div className="px-6 py-10 mx-auto w-full max-w-[760px]" data-testid="partners-page">
      <header className="mb-6">
        <div className="text-[11px] font-semibold uppercase tracking-[.06em] text-[var(--accent)]">
          Development Partner
        </div>
        <h1 className="mt-2 text-[26px] font-[620] text-[var(--tx-hi)] tracking-[-0.01em]">
          Build your estimating workflow with us
        </h1>
        <p className="mt-3 text-[14px] leading-[1.5] text-[var(--tx-mid)]">
          If your team writes a lot of estimates, the per-conversion plan isn&rsquo;t the right fit.
          We work with a small number of restoration orgs as development partners: we wire Antero
          Trail into how your team already works, build the integrations you need, and prioritize
          the features that move your numbers.
        </p>
      </header>

      <Card className="p-5 mb-6">
        <h2 className="text-[14px] font-[580] text-[var(--tx-hi)]">What you get</h2>
        <ul className="mt-3 space-y-2 text-[13px] text-[var(--tx-mid)]">
          <li>A direct line to the team building the product.</li>
          <li>Custom integrations with your tools and intake process.</li>
          <li>Onboarding and training for your estimators.</li>
          <li>Influence over the roadmap — the features you ask for get built.</li>
        </ul>
      </Card>

      <Card className="p-5 flex items-center justify-between gap-4 flex-wrap">
        <div>
          <div className="text-[12px] uppercase tracking-[.05em] text-[var(--tx-lo)]">
            Engagements
          </div>
          <div className="mt-1 text-[22px] font-[640] text-[var(--tx-hi)]">
            Starting at $5,000
          </div>
          <div className="mt-1 text-[12px] text-[var(--tx-lo)]">
            Scoped to what your team needs — tell us about your workflow.
          </div>
        </div>
        <Button variant="primary" asChild data-testid="partners-contact">
          <a href={mailto}>Talk to us</a>
        </Button>
      </Card>

      <p className="mt-4 text-[12px] text-[var(--tx-lo)]">
        Prefer email? Reach us at{' '}
        <a className="underline" href={mailto}>
          {CONTACT_EMAIL}
        </a>
        .
      </p>
    </div>
  );
}
